export interface UploadFileModel {
  path: any;
  file: File;
  uploadUrl: string;

  fileName: string;

  uploaded: boolean;
  loading: boolean;
}

export const initialUploadModel: UploadFileModel = {
  path: '', // for displaying to the user form
  file: null, // for displaying to the user form
  uploadUrl: '', // will be attached to the body

  fileName: '',

  uploaded: false, // user feedback
  loading: true // user feedback
};
